import { TextareaField } from '@hypeit-gmbh/hypeit-ui';
import { FieldValues, Path } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type EmailNotePropsType<T extends FieldValues> = {
  fieldName: Path<T>;
};

export const EmailNote = <T extends FieldValues>({
  fieldName,
}: EmailNotePropsType<T>): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <TextareaField<T>
      fieldName={fieldName}
      label={t('REPORTS.MAILING_FORM.EMAIL_NOTE')}
      description={t('REPORTS.MAILING_FORM.EMAIL_NOTE_DESCRIPTION')}
      placeholder={t('REPORTS.MAILING_FORM.EMAIL_NOTE_PLACEHOLDER')}
      minRows={3}
      autosize
    />
  );
};
